<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Appears</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo v-model="table.search"
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
	 	 		></v-text-field>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :loading="table.loading"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   pagination.sync="pagination"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn color="info" small fab @click="show(props.item)"><v-icon>fa fa-eye</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	   	<template v-slot:item.available="props">
	 	 	 	   		<td>
	 	 	 	   			<span class="success--text" v-if="props.item.available == 1">Disponible</span>
	 	 	 	   			<span class="warning--text" v-if="props.item.available == 0">No disponible</span>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	   	<template v-slot:item.deleted="props">
	 	 	 	   		<td>
	 	 	 	   			<span class="success--text" v-if="props.item.deleted == 0">Disponible</span>
	 	 	 	   			<span class="warning--text" v-if="props.item.deleted == 1">No disponible</span>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nuevo Appears</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 
		<v-dialog
		  v-model="modalShow.active"
		  :overlay="false"
		  max-width="1000px"
		  transition="dialog-transition"
		>
		<v-card>
			<v-card-title justify-left>
				<v-spacer></v-spacer>
			  <v-icon @click="modalShow.active = false">fas fa-times</v-icon>
			</v-card-title>
			<v-card-text>
			  <material-card
			    class="card-tabs"
			    color="info"
			  	:title="modalShow.product.product"
			    :text="'Version: ' + modalShow.product.version"
			    >
			    <v-card>
			      <v-card-title primary-title>
			      	<v-layout row wrap class="body-2">
			      	 	<v-flex xs6>
					        <v-list>
					          <v-list-item>
		                  <v-list-item-content>Link de documento</v-list-item-content>
		                  <v-list-item-content class="align-end"><a target="_blank" :href="modalShow.product.doclink">{{ modalShow.product.doclink }}</a></v-list-item-content>
		                </v-list-item>
		                <v-list-item>
		                  <v-list-item-content>Recurso</v-list-item-content>
		                  <v-list-item-content class="align-end">{{ modalShow.product.source }}</v-list-item-content>
		                </v-list-item>
		                <v-list-item>
		                  <v-list-item-content>DOI</v-list-item-content>
		                  <v-list-item-content class="align-end">{{ modalShow.product.doi }}</v-list-item-content>
		                </v-list-item>
		               </v-list>
		             </v-flex>
		             <v-flex xs6>
		             	<v-list>
		                <v-list-item>
		                  <v-list-item-content>Inicio de extracción</v-list-item-content>
		                  <v-list-item-content class="align-end">{{ modalShow.product.temporalextentstart }}</v-list-item-content>
		                </v-list-item>
		                <v-list-item>
		                  <v-list-item-content>Extencion temporal</v-list-item-content>
		                  <v-list-item-content class="align-end">{{ modalShow.product.temporalextentend }}</v-list-item-content>
		                </v-list-item>
		                <v-list-item>
		                  <v-list-item-content>Finalizacion de la extraccion</v-list-item-content>
		                  <v-list-item-content class="align-end">{{ modalShow.product.temporalextentend }}</v-list-item-content>
		                </v-list-item>
					        </v-list>
			      	 	 </v-flex> 
			      	 	 <v-flex xs12>
			      	 	   {{ modalShow.product.description }}
			      	 	 </v-flex>
			      	</v-layout>
			      </v-card-title>
			      <v-divider></v-divider>
			      <v-card-text>
			        <v-data-iterator
			          :items="modalShow.layers"
			         	:rows-per-page-items="rowsPerPageItems"
					      :pagination.sync="pagination"
					      content-tag="v-layout"
					      row wrap>
			          <v-flex
			            slot="item"
			            slot-scope="props"
			            xs12 sm6 md3 lg4>
			            <v-card>
			              <v-card-title><h4>{{ props.item.layer }}</h4></v-card-title>
			              <v-divider></v-divider>
			              <v-list dense class="body-2">
			                <v-list-item>
			                  <v-list-item-content>Tipo de dato</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.datatype }}</v-list-item-content>
			                </v-list-item>
			                <v-list-item>
			                  <v-list-item-content>Tipo de dato original</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.origdatatype }}</v-list-item-content>
			                </v-list-item>
			                <v-list-item>
			                  <v-list-item-content>Valor maximo original</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.origvalidmax }}</v-list-item-content>
			                </v-list-item>
			                <v-list-item>
			                  <v-list-item-content>Unidad</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.units }}</v-list-item-content>
			                </v-list-item>
			                 <v-list-item>
			                  <v-list-item-content>Tamaño de X</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.xsize }}</v-list-item-content>
			                </v-list-item>
			                <v-list-item>
			                  <v-list-item-content>Tamaño de X</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.ysize }}</v-list-item-content>
			                </v-list-item>
			                <v-list-item>
			                  <v-list-item-content>Valor de relleno</v-list-item-content>
			                  <v-list-item-content class="align-end">{{ props.item.fillvalue }}</v-list-item-content>
			                </v-list-item>
			              </v-list>
			            </v-card>
			          </v-flex>
			        </v-data-iterator>
			      </v-card-text>
			    </v-card>
			  </material-card>
			</v-card-text>
		</v-card>
		</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/modis',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				modalShow: {
					active: false,
					product: {},
					layers: []
				},
				selects: [],
				selected: [],
				rowsPerPageItems: [3, 6, 9, 12],
				pagination: {
        	rowsPerPage: 3
      	},
			}
		},
		methods: {
			getData(){
				axios.get(this.baseRoute).then((res) => {
					this.table.loading = false;
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
				}).catch((error) => {
					this.table.loading = false;
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			show(item){
				axios.get(this.baseRoute + '/getLayer/' + item.id).then((res) => {
					this.modalShow.product = res.data.product;
					this.modalShow.layers = res.data.layers;
					this.modalShow.active = true;

				});
			}
		},
		watch: {

		},
		computed: {

		},
	}
</script>